export default "__VITE_ASSET__RoWhLfxV__"